const SITE_ADMIN = 'site admin';
const RESTRICTED_SITE_ADMIN = 'restricted site admin';
const ORG_ADMIN = 'org admin';
const CLIENT_ADMIN = 'client admin';

const ADMIN_ROLES = [
  SITE_ADMIN,
  RESTRICTED_SITE_ADMIN,
  ORG_ADMIN,
  CLIENT_ADMIN,
];

export const isAdmin = userRole => ADMIN_ROLES.includes(userRole);
export const isSiteAdmin = userRole => userRole === SITE_ADMIN;
export const isRestrictedSiteAdmin = userRole =>
  userRole === RESTRICTED_SITE_ADMIN;
